import {useState} from "react";
import {useTenant} from "./hooks";

export function useRegenerateItemAccessCode() {
    const tenant = useTenant();
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    async function submit(itemUuid: string, success?: () => void) {
        if (!tenant) {
            setFailed(true);
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(tenant.rentalBaseUrl + '/items/regenerate-access-code', {
                method: 'post',
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({
                    itemUuid
                })
            });
            if (!response.ok) {
                setFailed(true);
            } else if (success) {
                success();
            }
        } catch (error) {
            setFailed(true);
        } finally {
            setLoading(false);
        }
    }
    return {loading, failed, submit}
}